import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";

// components
import { HomePageComponent } from "./home-page/home-page.component";
import { MainViewRouting } from "./main-view-routing.module";
import { AboutUsComponent } from "./about-us/about-us.component";
import { MainDashboardComponent } from "./main-dashboard/main-dashboard.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { ContactUsComponent } from './contact-us/contact-us.component';

// modules
import { BasicModule } from "@app/shared/basic-components/basic.module";


@NgModule({
  declarations: [
    HomePageComponent,
    MainDashboardComponent,
    AboutUsComponent,
    ChangePasswordComponent,
    ContactUsComponent,
  ],
  imports: [
    CommonModule,
    MainViewRouting,

    ReactiveFormsModule,
    BasicModule,
    FormsModule,
  ],
})
export class MainViewModule {}
